export default {
  'userMaintenance.addUser': 'Add New User',
  'userMaintenance.approvalApproved': 'Approved',
  'userMaintenance.approvalPending': 'Pending Approval',
  'userMaintenance.approvalRejected': 'Rejected',
  'userMaintenance.needsApproval': 'Needs Approval',
  'userMaintenance.awaitingApproval': 'Changes awaiting approval',
  'userMaintenance.copyUser': 'Copy User',
  'userMaintenance.goTo': 'Go to',
  'userMaintenance.header': 'User Management',
  'userMaintenance.role.admin': 'Admin',
  'userMaintenance.role.user': 'User',
  'userMaintenance.userDetails': 'User details',
  'userMaintenance.viewChanges': 'View Changes',
  'userMaintenance.viewUserChanges': 'View User Changes',
  'userMaintenance.viewUserSummary': 'View User Summary',

  'userMaintenance.header.actions': 'Actions',
  'userMaintenance.header.approvalStatus': 'Approval Status',
  'userMaintenance.header.lastLogin': 'Last Login',
  'userMaintenance.header.lockedStatus': 'Login Status',
  'userMaintenance.header.permissions': 'Permissions',
  'userMaintenance.header.status': 'Status',
  'userMaintenance.header.userCode': 'User ID',
  'userMaintenance.header.userName': 'User Name',
  'userMaintenance.header.userType': 'User Type',

  'userMaintenance.delete.title': 'Delete user',
  'userMaintenance.delete.message': 'Are you sure you want to delete',
  'userMaintenance.delete.success': 'The user has been deleted successfully',
  'userMaintenance.update.dualApprove.success':
    'User is updated. Changes are waiting for Secondary Admin Approval.',
  'userMaintenance.header.userPemissionsStatus': 'User permissions',
  'userMaintennce.permissionsLocked': 'locked',
  'userMaintennce.permissionsUnlocked': 'unlocked',

  // ACH Limits Table
  'userMaintenance.achLimitsTable.company': 'Company',
  'userMaintenance.achLimitsTable.initiation': 'Initiation',
  'userMaintenance.achLimitsTable.approval': 'Approval'
};
